import {
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { connections } from "../helpers/urlHelpers/internalApi/connections";

export interface CreateConnectionParams {
  memberId: number;
  note?: string;
  recommendationId?: number;
}

const createConnection = (params: CreateConnectionParams) =>
  reactQueryPost(connections.create(), {
    recipient_id: params.memberId,
    note: params.note,
    ...(params.recommendationId !== undefined && {
      recommendation_id: params.recommendationId,
    }),
  });

const acceptConnection = (connectionId: string) =>
  reactQueryPut(connections.accept(connectionId));

const ignoreConnection = (connectionId: string) =>
  reactQueryPut(connections.ignore(connectionId));

const withdrawConnection = (connectionId: string) =>
  reactQueryPut(connections.withdraw(connectionId));

export interface FlagConnectionParams {
  connectionId: string;
  reported_reason_body?: string;
  reported_reason_type: string;
}

const flagConnection = (params: FlagConnectionParams) =>
  reactQueryPut(connections.flag(params.connectionId), {
    reported_reason_type: params.reported_reason_type,
    reported_reason_body: params.reported_reason_body,
  });

export const connectionsApi = {
  createConnection,
  acceptConnection,
  ignoreConnection,
  withdrawConnection,
  flagConnection,
};
